import React from 'react'

const NoResults = () => {
  return (
    <div className="w-100 p-3 d-flex justify-content-center align-items-center">
        <h1>No Results Found</h1>
    </div>
  )
}

export default NoResults